import { useState } from "react";
import formatMoney from "../../../utils/formatMoney";
import ExpensesPanel from "./ExpensesPanel";

export default function ExpenseList({ data, year, center }: any) {
  const [isVisible, setVisible] = useState(false);
  const [expenses, setExpenses] = useState<any>([]);

  return (
    <>
      {data?.map((item: any) => (
        <button
          onClick={() => {
            setExpenses(item);
            setVisible(true);
          }}
          className="flex w-full justify-between items-center border-b py-1 hover:bg-red-100"
        >
          <div className="">{item?.name}</div>
          <div className="text-black">{formatMoney(item?.expenses)}</div>
        </button>
      ))}
      <ExpensesPanel
        isVisible={isVisible}
        setVisible={setVisible}
        expenses={expenses}
        title={"name"}
        total={2300}
        year={year}
        center={center}
      />
    </>
  );
}
